module.exports = __webpack_public_path__ + "img/sch4-gift-img.dbc87ea9.png";